import { render } from "./BaseChevron.vue?vue&type=template&id=c2f400ca&scoped=true"
import script from "./BaseChevron.vue?vue&type=script&lang=js"
export * from "./BaseChevron.vue?vue&type=script&lang=js"

import "./BaseChevron.vue?vue&type=style&index=0&id=c2f400ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f400ca"]])

export default __exports__